import { GET_ERRORS, GET_LOAD_DATA_ERRORS } from '../constants/actionTypes';

const initialState = {
  errors: null,
  dataLoadError: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ERRORS:
      return action.payload;
    case GET_LOAD_DATA_ERRORS:
      return {
        ...state,
        dataLoadError: action.payload,
      };
    default:
      return state;
  }
}
